module.exports = __webpack_public_path__ + "static/media/marketing3.63dd706c.webp";